import { AxiosInstance } from 'axios';

// Pobieranie koncertów
export const getConcerts = async (
  axiosInstance: AxiosInstance,
  setConcerts: (concerts: any[]) => void
): Promise<void> => {
  try {
    const response = await axiosInstance.get('/concerts/all');
    setConcerts(response.data);
    console.log(response.data);
  } catch (error) {
    console.error('Błąd podczas pobierania koncertów:', error);
    setConcerts([]);
  }
};

// Pobieranie koncertu po ID
export const getConcertById = async (
  axiosInstance: AxiosInstance,
  numericId: number,
  setConcert: (concert: any) => void
): Promise<void> => {
  try {
    const response = await axiosInstance.get(`/concerts/${numericId}`);
    console.log("Odpowiedź z API dla koncertu:", response.data);
    if (response.data && response.data.length > 0) {  // Jeśli odpowiedź to tablica
      setConcert(response.data[0]);  // Zakładając, że odpowiedź to tablica, weź pierwszy element
    } else {
      console.warn("Nieprawidłowe dane koncertu:", response.data);
      setConcert(null);
    }
  } catch (error) {
    console.error("Błąd podczas pobierania koncertu:", error);
    setConcert(null);
  }
};



// Dodanie nowego koncertu
export const addConcert = async (
  axiosInstance: AxiosInstance,
  concert: { place: string; date: string; host: string },
  onSuccess: (response: any) => void,
  onError: (error: any) => void
): Promise<void> => {
  try {
    const response = await axiosInstance.post('/concerts', {
      place: concert.place,
      date: concert.date,
      host: concert.host,
    });
    onSuccess(response.data);
  } catch (error) {
    console.error('Błąd podczas dodawania koncertu:', error);
    onError(error);
  }
};

// Aktualizacja koncertu
export const updateConcert = async (
  axiosInstance: AxiosInstance,
  id: number,
  concert: { place: string; date: string; host: string },
  onSuccess: (response: any) => void,
  onError: (error: any) => void
): Promise<void> => {
  try {
    const response = await axiosInstance.put(`/concerts/${id}`, {
      place: concert.place,
      date: concert.date,
      host: concert.host,
    });
    onSuccess(response.data);
  } catch (error) {
    console.error('Błąd podczas aktualizacji koncertu:', error);
    onError(error);
  }
};

// Usunięcie koncertu
export const deleteConcert = async (
  axiosInstance: AxiosInstance,
  id: number,
  onSuccess: (response: any) => void,
  onError: (error: any) => void
): Promise<void> => {
  try {
    const response = await axiosInstance.delete(`/concerts/${id}`);
    onSuccess(response.data);
  } catch (error) {
    console.error('Błąd podczas usuwania koncertu:', error);
    onError(error);
  }
};

// Pobieranie wersji koncertu
export const getConcertVersion = async (
  axiosInstance: AxiosInstance,
  id: number,
  setVersion: (version: number) => void
): Promise<void> => {
  try {
    const response = await axiosInstance.get(`/concerts/version/${id}`);
    setVersion(response.data.version);
  } catch (error) {
    console.error('Błąd podczas pobierania wersji koncertu:', error);
    setVersion(0);
  }
};

export const getConcertYears = async (
  axiosInstance: AxiosInstance,
  setYears: (years: string[]) => void
): Promise<void> => {
  try {
    const response = await axiosInstance.get('/concerts/years');
    setYears(response.data.map((year: number) => year.toString()) || []);
    console.log(response.data);
  } catch (error) {
    console.error('Błąd podczas pobierania lat koncertów:', error);
    setYears([]);
  }
};
